import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseActions } from '../BaseActions';
import { AddToCartActionOption, CartEvents } from '@wix/wixstores-client-core';
import { getLeanGQLCartFromSDK } from '../../viewer-script/current-cart-service/getLeanGQLCartFromSDK';
var TinyCartActions = /** @class */ (function (_super) {
    __extends(TinyCartActions, _super);
    function TinyCartActions(_a) {
        var siteStore = _a.siteStore, origin = _a.origin, currentCartService = _a.currentCartService;
        var _this = _super.call(this, { siteStore: siteStore, origin: origin }) || this;
        _this.currentCartService = currentCartService;
        return _this;
    }
    TinyCartActions.prototype.showTinyCart = function (_a) {
        var _b = _a === void 0 ? {} : _a, addedProductId = _b.addedProductId;
        return __awaiter(this, void 0, void 0, function () {
            var leanGQLCartModel;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, getLeanGQLCartFromSDK(this.currentCartService)];
                    case 1:
                        leanGQLCartModel = _c.sent();
                        if (addedProductId) {
                            this.siteStore.pubSubManager.publish(CartEvents.CHANGED, __assign(__assign({}, leanGQLCartModel), { extraParams: { origin: 'ShowTinyCart' }, eventOptions: {
                                    shouldOpenCart: true,
                                    addToCartActionOption: AddToCartActionOption.TINY_CART,
                                    addedProductId: addedProductId,
                                    originatedInWorker: true,
                                }, reason: 'ShowTinyCart' }));
                        }
                        else {
                            this.siteStore.pubSubManager.publish('Tinycart.Show', null);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TinyCartActions.prototype.hideTinyCart = function () {
        this.siteStore.pubSubManager.publish('Tinycart.Hide', null);
    };
    return TinyCartActions;
}(BaseActions));
export { TinyCartActions };
//# sourceMappingURL=TinyCartActions.js.map